import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAlertIssueSync: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-alert-issue-sync", jiraSpaEntry: "async-jira-eoc-alert-issue-syncing" */ '@jira/eoc__eoc-alert-issue-syncing/src/index.tsx'
	).then((module) => module.AlertIssueSync),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAlertIssueSyncCreate: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-alert-issue-sync-create", jiraSpaEntry: "async-jira-eoc-alert-issue-syncing-create" */ '@jira/eoc__eoc-alert-issue-syncing/src/index.tsx'
	).then((module) => module.AlertIssueSyncCreate),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAlertIssueSyncDetail: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-alert-issue-sync-detail", jiraSpaEntry: "async-jira-eoc-alert-issue-syncing-detail" */ '@jira/eoc__eoc-alert-issue-syncing/src/index.tsx'
	).then((module) => module.AlertIssueSyncDetail),
);
